import React from 'react'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import OrderDeliveryButton from './OrderDeliveryButton'
import { hero, heroText, logo, mobileHero, mobileHeroText } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          h="100vh"
          w="100%"
          image={`url(${mobileHero}) bottom / cover no-repeat`}
          column
          justifyBetween
        >
          <Header />
          <CFView
            textCenter
            column
            center
            bg="rgba(0,0,0,0.7)"
            w="100%"
            pt="8px"
            pb="5px"
          >
            <CFImage
              src={mobileHeroText}
              w="80%"
              maxWidth="450px"
              alt="Sushi Gio hero text"
              zIndex={98}
            />
            <CFView w="100%" pulsate mt="10px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView
          h="100vh"
          maxHeight="700px"
          w="100%"
          image={`url(${hero}) center / cover no-repeat`}
          boxShadow="0px 2px 4px rgba(0, 0, 0, 0.25);"
          zIndex={90}
          column
          justifyBetween
        >
          <Header />
          <CFView row center bg="rgba(0,0,0,0.7)" pt="10px" pb="4px">
            <CFImage
              src={heroText}
              w="100%"
              maxWidth="450px"
              alt="Sushi Gio hero text"
              zIndex={98}
            />
            <CFView pulsate ml="20px">
              <OrderPickupButton />
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
